const state = {
    date_form: {
        category_id: '',
        tags: -1,
        age: -1,
        career: -1,
        area: -1,
        years: -1,
        price_id: -1,
        order: '',
        sort: '',
        collect: 0,
    },
}
const mutations = {
    SET_DATE_FORM(state, data) {
        console.log("data:", data);
        state.date_form[data.index] = data.data
        console.log("state.date_form:", state.date_form);
    },
    RESET_FILL_FORM(state, date_form) {
        if (date_form) {
            state.date_form = date_form;
        } else {
            state.date_form = {
                category_id: state.date_form.category_id,
                portal_id: -1,
                classify_id: -1,
                area_id: -1,
                price_id: -1,
                collect: 0,
                sort: '',
                order: '',
            }
        }
    },
}
export default {
    state,
    mutations
}